'use strict';

const Backbone = require('backbone');

const PageIndex = require('pages/PageIndex/PageIndex');

module.exports = Backbone.Router.extend({

    routes: {
        '': 'index'
    },

    initialize: function () {

    },

    index: function () {
        new PageIndex({router: this});
    },

    start: function () {
        Backbone.history.start({
            pushState: true,
            root: '/',
            silent: false
        });
    }
});
